
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface RequestHeaderProps {
  title: string;
  buyerName: string;
  buyerAvatar: string | null;
  createdAt: string;
}

const RequestHeader = ({ title, buyerName, buyerAvatar, createdAt }: RequestHeaderProps) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(date);
  };

  return (
    <div className="mb-8">
      <h1 className="text-3xl font-bold mb-4">{title}</h1>
      <div className="flex items-center gap-4">
        <Avatar className="h-10 w-10">
          <AvatarImage src={buyerAvatar || ""} alt={buyerName} />
          <AvatarFallback>{buyerName.slice(0, 2).toUpperCase()}</AvatarFallback>
        </Avatar>
        <div>
          <div className="font-medium">{buyerName}</div>
          <div className="text-sm text-gray-500">
            Posted on {formatDate(createdAt)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestHeader;
